import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { api, ApiError } from './api.js';

type AuthState = 'loading' | 'logged-out' | 'logged-in' | 'setup-required';
const AuthCtx = createContext<{ state: AuthState; refresh: () => Promise<void>; setState: (s: AuthState) => void }>({ state: 'loading', refresh: async () => {}, setState: () => {} });

export function AuthProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<AuthState>('loading');
  const refresh = async () => {
    try {
      const status = await api.getStatus();
      if (!status.install_complete || !status.tado_connected) { setState('setup-required'); return; }
      try { await api.me(); setState('logged-in'); }
      catch (e) { if (e instanceof ApiError && e.status === 401) setState('logged-out'); else throw e; }
    } catch { setState('logged-out'); }
  };
  useEffect(() => { void refresh(); }, []);
  return <AuthCtx.Provider value={{ state, refresh, setState }}>{children}</AuthCtx.Provider>;
}
export const useAuth = () => useContext(AuthCtx);
